import React, { useState,useEffect } from "react";
import TextInput from "../fields/TextInput";
import { MuiTelInput, matchIsValidTel } from "mui-tel-input";
import { IoLocationOutline } from "react-icons/io5";
import MapWithModal from "../fields/MapWithLocation";

const PersonalInformation = ({
  phone,
  onChange,
  errmsg,
  handlephone,
  setPersonalDetail,
  personalDetail,
  setErrMsg,
}) => {
  const [location, setLocation] = useState(personalDetail?.address || "");

  useEffect(() => {
    handleBookingInfo({ target: { name: "address", value: location } });
  }, [location]);

  const handleBookingInfo = (event) => {
    const { name, value } = event.target;
    setPersonalDetail((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  return (
    <div className="card border-0 radio-shadow h-100">
      <h3 className="booking-label border-0 font card-header">
        Personal Information
      </h3>

      <div className="booking-div-space card-body">
        <div className="mb-3">
          <TextInput
            type="text"
            labelName="Full Name"
            id="fullName"
            placeholder="Enter Full Name"
            size="small"
            name="fullName"
            value={personalDetail?.fullName}
            onChange={onChange}
            error={!!errmsg?.fullName}
            helperText={errmsg.fullName}
          />
        </div>
        <div className="mb-3">
          <TextInput
            type="email"
            labelName="Email Id"
            id="email"
            placeholder="Enter Email"
            size="small"
            name="email"
            value={personalDetail?.email}
            onChange={onChange}
            error={!!errmsg?.email}
            helperText={errmsg.email}
          />
        </div>
        <div className="mb-3">
          <label className="input-label my-2">
            Phone Number<span style={{ color: "red" }}>*</span>
          </label>
          <MuiTelInput
            // disableFormatting
            error={!!errmsg?.phone}
            name="phone"
            defaultCountry="ZW"
            value={phone}
            onChange={handlephone}
            variant="outlined"
            size="small"
            sx={{ width: "100%" }}
            helperText={errmsg?.phone}
          />
        </div>
        <div className="mb-3">
        <label className="input-label my-2">
        Address<span style={{ color: "red" }}>*</span>
          </label>
        <MapWithModal
            type="filterSrch"
            placeholder="Enter Address"
            error={!!errmsg?.address}
            helperText={errmsg?.address}
            setLocation={setLocation}
            location={personalDetail?.address}
          />
          {/* <TextInput
            type="text"
            labelName="Address"
            id="address"
            placeholder="Enter Address"
            size="small"
            name="address"
            value={personalDetail?.address}
            onChange={onChange}
            error={!!errmsg?.address}
            helperText={errmsg?.address}
          /> */}
          {/* <div className="">
            <p className="accentColor mb-lg-2 mb-2 text-start fw-medium">
              <IoLocationOutline className="fs18 me-1" />
              Pick-up Location
              <span className="text-danger">*</span>
            </p>
            <MapWithModal
              type="filterSrch"
              placeholder="Enter Pick-up location"
              error={!!errmsg?.address}
              helperText={errmsg?.address}
              setLocation={setLocation}
              location={location}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default PersonalInformation;
